import { render, staticRenderFns } from "./SecondarySubmit.vue?vue&type=template&id=d0f50cc4&scoped=true"
import script from "./SecondarySubmit.vue?vue&type=script&lang=js"
export * from "./SecondarySubmit.vue?vue&type=script&lang=js"
import style0 from "./SecondarySubmit.vue?vue&type=style&index=0&id=d0f50cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f50cc4",
  null
  
)

export default component.exports